import { Group, Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressBar, Text, Tooltip } from '@feathr/components';

import * as styles from './RunningProgress.css';

interface IRunningProgressProps {
  /** The line under the bar, such as "In progress". */
  caption: string;
  /** The bar's accessible name. */
  label: string;
  percent: number;
  tooltip?: string;
}

/** The Status cell of a job that is still running: its bar, a caption and its percent. */
function RunningProgress({
  caption,
  label,
  percent,
  tooltip,
}: Readonly<IRunningProgressProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const progress = (
    <Stack className={styles.root} gap={theme.spacing['1']}>
      <ProgressBar aria-label={label} shade={600} theme={'yellow'} value={percent} />
      <Group justify={'space-between'} wrap={'nowrap'}>
        <Text.SmallRegular>{caption}</Text.SmallRegular>
        <Text.SmallMedium>{t('{{percent}}%', { percent })}</Text.SmallMedium>
      </Group>
    </Stack>
  );

  return tooltip ? (
    <Tooltip focusable={true} title={tooltip}>
      {progress}
    </Tooltip>
  ) : (
    progress
  );
}

export default RunningProgress;
